import { ArmsRum, initArmsRum, ENV } from '@mogic/rum'
import { UserInfo } from '@/api'
import { ignoreCallback } from '@da-vinci/utils'

export function initArms() {
  !__APP_DEV__ &&
    initArmsRum({
      pid: 'ismgnd2lzr@72d4fe7d605b564',
      endpoint: 'https://ismgnd2lzr-default-cn.rum.aliyuncs.com',
      userId: getUserId() || '',
      username: getUsername() || '',
      spaMode: 'history',
      env: __APP_ENV__ as ENV,
      tracing: true,
      ignoreCallback: ignoreCallback,
    })
}

// 监听 userInfo 变化，及时同步ARMS
export function useUpdateRumConfig() {
  if (__APP_DEV__) {
    return
  }
  const store = useStore()
  const userInfo = computed(() => store.user.userInfo)
  watch(
    () => userInfo.value,
    (newValue) => {
      ArmsRum.setConfig('user', { name: getUserStr(newValue) })
    }
  )
}

const getUserStr = (userInfo: UserInfo | undefined) => {
  if (!userInfo) {
    return ''
  }
  return `${String(userInfo?.userId || '')}-${String(userInfo?.username || '')}`
}

export function getUserId() {
  const store = useStore()
  return store.user.userInfo?.userId || ''
}

export function getUsername() {
  const store = useStore()
  return store.user.userInfo?.username || ''
}
